import axiosConfig from './axiosConfigInstance';

const SESSION_KEY = 'payment_ui_click_session_id';

const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = `pui_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return `pui_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }
};

export const trackPaymentUiClick = (payload = {}) => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    const body = {
      sessionId: getSessionId(),
      traceId: payload.traceId,
      eventName: payload.eventName,
      eventAction: payload.eventAction || 'click',
      paymentMethod: payload.paymentMethod || 'other',
      page: payload.page || window.location.pathname,
      planId: payload.planId,
      billingCycle: payload.billingCycle,
      email: payload.email || userData.email,
      userId: payload.userId || userData._id || userData.id || userData.userId,
      source: payload.source || 'unknown',
      clientTimestamp: new Date().toISOString(),
      meta: payload.meta || {},
    };

    return axiosConfig
      .post(`${import.meta.env.VITE_APP_API_URL}/chargebee/payment-ui-click`, body)
      .catch(() => null);
  } catch {
    return Promise.resolve(null);
  }
};
